import { Common } from '@icc/shared/helpers';
import { ConfigurationsService } from '@icc/configurator/shared';
import { AppConfigFactory, APP_CONFIG, TranslateService, ConfiguratorsDataService } from '@icc/shared';
import { core } from '@icc/shared/helpers';
import { Injectable, Inject } from '@angular/core';
import { DoorActiveConfiguration, IccFilling, WindowActiveConfiguration } from '@icc/window-door/types';
import { ActiveSash } from '@icc/window-door/types';
import { WindowFacade } from '../+state/window-door.facade';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { FillingsService } from '../modules/glazings/fillings.service';

@Injectable()
export class FillingsFacade {
    loadedData = false;

    oneFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'default'))
    );

    doorActiveFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'doorActive'))
    );

    doorPassiveFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'doorPassive'))
    );

    windowFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'window'))
    );

    leftLightFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'leftLight'))
    );

    rightLightFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'rightLight'))
    );

    topLightFillingBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.fillingBox(conf, 'topLight'))
    );

    doorActiveModelBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.modelBox(conf, 'doorActive'))
    );

    doorActiveInnerModelBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.modelBox(conf, 'doorActiveInner'))
    );

    doorPassiveModelBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.modelBox(conf, 'doorPassive'))
    );

    doorPassiveInnerModelBox$ = this.windowFacade.configuration$.pipe(
        map(conf => this.modelBox(conf, 'doorPassiveInner'))
    );

    availableDecoPanelSecondColor$ = this.windowFacade.configuration$.pipe(
        map(conf => conf.Sashes.some(
                s =>
                    (s.type?.type === 'DRA'
                        || s.type?.type === 'DRP'
                        || s.type?.type === 'DOA'
                        || s.type?.type === 'DOP')
                    && s.glazing
                    && s.glazing.type === (conf.System.door_type ? 'door_panels' : 'deco_panels')
                    && s.glazing.available_second_color
            ))
    );

    availableInnerDecoPanelSecondColor$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorActive');
            if (conf.type === 'door' && conf.OwnedSashesTypes.doorActive && sash && sash.panelInner && sash.panelInner.type === 'door_panels') {
                return sash.panelInner.available_second_inside_color;
            }
            return sash && sash.glazing
                && sash.glazing.type === (conf.System.door_type ? 'door_panels' : 'deco_panels')
                && sash.glazing.available_second_color;
        })
    );

    outerFirstColor$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorActive');
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColor
            ) {
                return sash.glazing.selectedColor.outer;
            }
        })
    );

    innerFirstColor$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorActive');
            if (
                sash
                && sash.panelInner
                && sash.panelInner.selectedColor
            ) {
                return sash.panelInner.selectedColor.inner;
            }
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColor
            ) {
                return sash.glazing.selectedColor.inner;
            }
        })
    );

    outerOtherColor$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorActive');
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColorSecond
            ) {
                return sash.glazing.selectedColorSecond.outer;
            }
        })
    );

    innerOtherColor$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorActive');
            if (
                sash
                && sash.panelInner
                && sash.panelInner.selectedColorSecond
            ) {
                return sash.panelInner.selectedColorSecond.inner;
            }
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColorSecond
            ) {
                return sash.glazing.selectedColorSecond.inner;
            }
        })
    );

    outerFirstColorPassive$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorPassive');
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColor
            ) {
                return sash.glazing.selectedColor.outer;
            }
        })
    );

    innerFirstColorPassive$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorPassive');
            if (
                sash
                && sash.panelInner
                && sash.panelInner.selectedColor
            ) {
                return sash.panelInner.selectedColor.inner;
            }
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColor
            ) {
                return sash.glazing.selectedColor.inner;
            }
        })
    );

    outerOtherColorPassive$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorPassive');
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColorSecond
            ) {
                return sash.glazing.selectedColorSecond.outer;
            }
        })
    );

    innerOtherColorPassive$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorPassive');
            if (
                sash
                && sash.panelInner
                && sash.panelInner.selectedColorSecond
            ) {
                return sash.panelInner.selectedColorSecond.inner;
            }
            if (
                sash
                && sash.glazing
                && sash.glazing.selectedColorSecond
            ) {
                return sash.glazing.selectedColorSecond.inner;
            }
        })
    );

    selectedLightGlazingId$ = this.windowFacade.configuration$.pipe(
        map(conf => conf.OneFilling.doorLight || null)
    );

    availableDecoPanelSecondColorPassive$ = this.windowFacade.configuration$.pipe(
        map(conf => {
            const sash = this.getDoorSash(conf, 'doorPassive');
            return sash
                   && sash.glazing
                    && sash.glazing.type === (conf.System.door_type ? 'door_panels' : 'deco_panels')
                    && sash.glazing.available_second_color;
        })
    );

    hasDoorActiveDifferentColors$ = combineLatest([
        this.outerFirstColor$,
        this.innerFirstColor$,
        this.outerOtherColor$,
        this.innerOtherColor$,
        this.availableDecoPanelSecondColor$,
        this.availableInnerDecoPanelSecondColor$,
    ]).pipe(
        map(([
            outerFirstColor,
            innerFirstColor,
            outerOtherColor,
            innerOtherColor,
            availableDecoPanelSecondColor,
            availableInnerDecoPanelSecondColor,
        ]) => outerFirstColor?.id
                    && innerFirstColor?.id
                    && outerFirstColor?.id !== innerFirstColor?.id
                || availableDecoPanelSecondColor
                    && availableInnerDecoPanelSecondColor
                    && outerOtherColor?.id
                    && innerOtherColor?.id
                    && outerOtherColor?.id !== innerOtherColor?.id)
    );

    hasDoorPassiveDifferentColors$ = combineLatest([
        this.outerFirstColorPassive$,
        this.innerFirstColorPassive$,
    ]).pipe(
        map(([
            outerFirstColorPassive,
            innerFirstColorPassive,
        ]) => (outerFirstColorPassive?.id && innerFirstColorPassive?.id && outerFirstColorPassive?.id !== innerFirstColorPassive?.id)
        )
    );

    hasSecondDoorPassiveDifferentColors$ = combineLatest([
        this.outerFirstColorPassive$,
        this.innerFirstColorPassive$,
        this.outerOtherColorPassive$,
        this.innerOtherColorPassive$,
        this.availableDecoPanelSecondColorPassive$
    ]).pipe(
        map(([
            outerFirstColorPassive,
            innerFirstColorPassive,
            outerOtherColorPassive,
            innerOtherColorPassive,
            availableDecoPanelSecondColorPassive
        ]) => availableDecoPanelSecondColorPassive
                    && outerFirstColorPassive?.id
                    && innerFirstColorPassive?.id
                    && outerFirstColorPassive?.id !== innerFirstColorPassive?.id
                || availableDecoPanelSecondColorPassive
                    && outerOtherColorPassive?.id
                    && innerOtherColorPassive?.id
                    && outerOtherColorPassive?.id !== innerOtherColorPassive?.id)
    );

    hasDifferentColors$ = combineLatest([
        this.hasDoorActiveDifferentColors$,
        this.hasSecondDoorPassiveDifferentColors$,
        this.hasDoorPassiveDifferentColors$
    ]).pipe(
        map(([
            hasDoorActiveDifferentColors,
            hasSecondDoorPassiveDifferentColors,
            hasDoorPassiveDifferentColors
        ]) => hasDoorActiveDifferentColors || hasSecondDoorPassiveDifferentColors || hasDoorPassiveDifferentColors)
    );

    constructor(
        private translateService: TranslateService,
        private windowFacade: WindowFacade,
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private fillingsService: FillingsService
    ) {}

    init() {
        this.loadedData = true;
    }
    fillingBox(conf: DoorActiveConfiguration | WindowActiveConfiguration, boxType: string) {
        let img = null;
        let title = this.translateService.instant('WINDOW|Wypełnienie');
        let name = this.translateService.instant('INTERFACE|Brak');
        let u = this.translateService.instant('INTERFACE|brak danych');
        let oneGlazing = conf.OneGlazing;
        let bondedGlazing = false;
        let partlyBondedGlazing = false;
        let panelType = 'Inset';
        let type = 'glazing';
        let panelGlazingName = '';
        let panelTrimName = '';
        let color = '';
        let color2 = '';
        let editGlazing = false;

        let oneBondedGlazing = conf.OneBondedGlazing;
        const sash = this.getDoorSash(conf, boxType);

        let show = false;
        if (typeof boxType === 'undefined' || boxType === 'default') {
            show = conf.type !== 'door' || conf.OneGlazing;
        } else if (boxType === 'doorActive') {
            show = conf.type === 'door' && !conf.OneGlazing && conf.OwnedSashesTypes.doorActive;
        } else if (boxType === 'doorPassive') {
            show = conf.type === 'door' && !conf.OneGlazing && conf.OwnedSashesTypes.doorPassive;
        } else if (boxType === 'window') {
            show = conf.type === 'door' && !conf.OneGlazing && conf.OwnedSashesTypes.window;
        } else if (boxType === 'leftLight') {
            show = conf.type === 'door' && conf.OwnedSashesTypes.doorLeftLight;
        } else if (boxType === 'rightLight') {
            show = conf.type === 'door' && conf.OwnedSashesTypes.doorRightLight;
        } else if (boxType === 'topLight') {
            show = conf.type === 'door' && conf.OwnedSashesTypes.doorTopLight;
        }

        if (sash && sash.glazing) {
            img = '/files/filling/' + sash.glazing.image;

            if (typeof boxType === 'undefined' || boxType === 'default') {
                if (
                    (!oneGlazing && conf.type !== 'door')
                    || (oneGlazing && sash.glazing.type === 'glazing')
                ) {
                    title = this.translateService.instant('WINDOW|Pakiet szybowy');
                } else if (oneGlazing && sash.glazing.type === 'pvc_panels') {
                    title = this.translateService.instant('WINDOW|Panel wypełnieniowy');
                }
            } else {
                if (boxType === 'doorActive') {
                    title = this.translateService.instant('DOOR|Wypełnienie skrzydła aktywnego');
                    oneGlazing = Boolean(conf.OneFilling.doorActive);
                    oneBondedGlazing = conf.OneBondedGlazingPerSash.doorActive;
                } else if (boxType === 'doorPassive') {
                    title = this.translateService.instant('DOOR|Wypełnienie skrzydła biernego');
                    oneGlazing = Boolean(conf.OneFilling.doorPassive);
                    oneBondedGlazing = conf.OneBondedGlazingPerSash.doorPassive;
                } else if (boxType === 'window') {
                    title = this.translateService.instant('DOOR|Wypełnienie naświetli');
                    oneGlazing = Boolean(conf.OneFilling.window);
                    oneBondedGlazing = conf.OneBondedGlazingPerSash.window;
                } else if (boxType === 'topLight') {
                    title = this.translateService.instant('DOOR|Wypełnienie doświetla górnego');
                    oneGlazing = Boolean(conf.OneFilling.doorTopLight);
                    oneBondedGlazing = conf.OneBondedGlazingPerSash.doorTopLight;
                } else if (boxType === 'leftLight') {
                    title = this.translateService.instant('DOOR|Wypełnienie doświetla lewego');
                    oneGlazing = Boolean(conf.OneFilling.doorLeftLight);
                    oneBondedGlazing = conf.OneBondedGlazingPerSash.doorLeftLight;
                } else if (boxType === 'rightLight') {
                    title = this.translateService.instant('DOOR|Wypełnienie doświetla prawego');
                    oneGlazing = Boolean(conf.OneFilling.doorRightLight);
                    oneBondedGlazing = conf.OneBondedGlazingPerSash.doorRightLight;
                }
            }

            name = sash.glazing.name;
            if (this.config().IccConfig.Configurators.showFillingsProducers && sash.glazing.producer) {
                name += ` (${sash.glazing.producer})`;
            }
            if (sash.glazing.u) {
                u = sash.glazing.u + ' W/m2*K';
            }

            bondedGlazing =
                this.config().IccConfig.Configurators.bondedGlazingAvailable
                && oneBondedGlazing
                && sash.bondedGlazing;
            partlyBondedGlazing =
                this.config().IccConfig.Configurators.bondedGlazingAvailable && !oneBondedGlazing;
            type = sash.glazing.type;
            panelType = sash.panelType;
            if (sash.panelGlazing) {
                panelGlazingName = sash.panelGlazing.name;
            }
            if (sash.panelTrim) {
                panelTrimName = sash.panelTrim.name;
            }
            color = this.getFillingColorsDescription(conf, sash.glazing);
            if (sash.glazing.available_second_color) {
                color2 = this.getFillingColorsDescription(conf, sash.glazing, true);
            }

            boxType = boxType === 'default' ? this.doorOneGlazingType(conf) : boxType;

        }
        return {
            img,
            title,
            name,
            color,
            color2,
            u,
            oneGlazing,
            bondedGlazing,
            partlyBondedGlazing,
            panelType,
            type,
            panelGlazingName,
            panelTrimName,
            show,
            boxType,
        };
    }

    modelBox(conf: DoorActiveConfiguration | WindowActiveConfiguration, boxType: string) {
        let img = null;
        let title = this.translateService.instant('DOOR|Model');
        let name = this.translateService.instant('INTERFACE|Brak');
        let oneGlazing = conf.OneGlazing;
        let panelType = 'Inset';
        let type = 'deco_panels';
        let panelGlazingName = '';
        let panelTrimName = '';
        let innerPanelTrimName = '';
        let color = '';
        let color2 = '';
        let disabledButton1 = false;
        let predefinedLayout = false;

        const sash = this.getDoorSash(conf, boxType);

        let show = false;
        if (typeof boxType === 'undefined' || boxType === 'default' || boxType === 'doorActive') {
            show = conf.type === 'door' && (conf.OneGlazing || conf.OwnedSashesTypes.doorActive);
        } else if (boxType === 'doorActiveInner') {
            show = conf.type === 'door' && conf.System?.door_type && conf.OwnedSashesTypes.doorActive;
        } else if (boxType === 'doorPassive') {
            show = conf.type === 'door' && conf.OwnedSashesTypes.doorPassive;
        } else if (boxType === 'doorPassiveInner') {
            show = conf.type === 'door' && conf.System?.door_type && conf.OwnedSashesTypes.doorPassive;
        }

        let showOptions = false;
        let showTrims = false;
        if (sash && sash.glazing) {
            if (boxType === 'doorActive') {
                title = this.translateService.instant('DOOR|Model skrzydła aktywnego');
                oneGlazing = Boolean(conf.OneFilling.doorActive);
                showTrims = this.fillingsService.getPanelTrimsByFieldType(boxType, conf).panelTrims.length > 0;
                showOptions = this.fillingsService.getPanelGlazingsByFieldType(boxType, conf)['panelGlazings'].length > 0
                    || this.fillingsService.getMatchingFillingVariantsForField(conf, boxType, sash).length > 1
                    || sash.glazing?.type === 'deco_panels' && showTrims
            } else if (boxType === 'doorActiveInner') {
                title = this.translateService.instant('DOOR|Model wewnętrzny skrzydła aktywnego');
                oneGlazing = Boolean(conf.OneFilling.doorActiveInner);
                showTrims = this.fillingsService.getPanelTrimsByFieldType(boxType, conf, sash, 'inside').panelTrims.length > 0;
            } else if (boxType === 'doorPassive') {
                title = this.translateService.instant('DOOR|Model skrzydła biernego');
                oneGlazing = Boolean(conf.OneFilling.doorPassive);
                showTrims = this.fillingsService.getPanelTrimsByFieldType(boxType, conf).panelTrims.length > 0;
                showOptions = this.fillingsService.getPanelGlazingsByFieldType(boxType, conf)['panelGlazings'].length > 1
                    || this.fillingsService.getMatchingFillingVariantsForField(conf, boxType, sash).length > 1
                    || sash.glazing?.type === 'deco_panels' && showTrims;
            } else if (boxType === 'doorPassiveInner') {
                title = this.translateService.instant('DOOR|Model wewnętrzny skrzydła biernego');
                oneGlazing = Boolean(conf.OneFilling.doorPassiveInner);
                showTrims = this.fillingsService.getPanelTrimsByFieldType(boxType, conf, sash, 'inside').panelTrims.length > 0;
            }
            if (['doorActiveInner', 'doorPassiveInner'].indexOf(boxType) > -1 && sash.panelInner) {
                name = sash.panelInner.name;
                type = sash.panelInner.type;
                img = '/files/filling/' + (sash.panelInner.image_in ? sash.panelInner.image_in : sash.panelInner.image);
                color = this.getFillingColorsDescription(conf, sash.panelInner);
                if (sash.panelInner.available_second_inside_color) {
                    color2 = this.getFillingColorsDescription(conf, sash.panelInner, true);
                }
                if (sash.innerPanelTrim?.name) {
                    panelTrimName = sash.innerPanelTrim.name;
                }
            } else {
                name = sash.glazing.name;
                type = sash.glazing.type;
                img = '/files/filling/' + sash.glazing.image;
                panelType = sash.panelType;
                if (sash.panelGlazing) {
                    panelGlazingName = sash.panelGlazing.name;
                }
                if (sash.panelTrim) {
                    panelTrimName = sash.panelTrim.name;
                }
                if (sash.innerPanelTrim) {
                    innerPanelTrimName = sash.innerPanelTrim.name;
                }
                color = this.getFillingColorsDescription(conf, sash.glazing);
                if (sash.glazing.available_second_color) {
                    color2 = this.getFillingColorsDescription(conf, sash.glazing, true);
                }
            }

            boxType = boxType === 'default' ? this.doorOneGlazingType(conf) : boxType;

        } else if (
            sash
            && !sash.glazing
            && sash.intSashes?.length
            && sash.intSashes.some(i => i.glazing)
        ) {
            if (boxType === 'doorActive') {
                title = this.translateService.instant('DOOR|Model skrzydła aktywnego');
            } else if (boxType === 'doorActiveInner') {
                title = this.translateService.instant('DOOR|Model wewnętrzny skrzydła aktywnego');
            } else if (boxType === 'doorPassive') {
                title = this.translateService.instant('DOOR|Model skrzydła biernego');
            } else if (boxType === 'doorPassiveInner') {
                title = this.translateService.instant('DOOR|Model wewnętrzny skrzydła biernego');
            }
            const filledFields = sash.intSashes.filter(i => i.glazing);
            const firstWithFilling = filledFields[0];
            const allSameFilling = filledFields.every(
                i => i.glazing?.id === firstWithFilling.glazing?.id
            );
            if (allSameFilling && firstWithFilling?.glazing) {
                name = firstWithFilling.glazing.name;
                type = firstWithFilling.glazing.type;
                img = '/files/filling/' + firstWithFilling.glazing.image;
                panelType = firstWithFilling.panelType || sash.panelType || 'Inset';
                oneGlazing = true;
                if (firstWithFilling.panelGlazing?.name) {
                    panelGlazingName = firstWithFilling.panelGlazing.name;
                }
                if (firstWithFilling.panelTrim?.name) {
                    panelTrimName = firstWithFilling.panelTrim.name;
                }
                if (firstWithFilling.innerPanelTrim?.name) {
                    innerPanelTrimName = firstWithFilling.innerPanelTrim.name;
                }
                color = this.getFillingColorsDescription(conf, firstWithFilling.glazing);
                if (firstWithFilling.glazing.available_second_color) {
                    color2 = this.getFillingColorsDescription(
                        conf,
                        firstWithFilling.glazing,
                        true
                    );
                }
            } else {
                name = this.translateService.instant('DOOR|Wzór wypełnienia');
                type = 'deco_panels';
                panelType = 'Inset';
                oneGlazing = false;
                if (firstWithFilling?.glazing?.image) {
                    img = '/files/filling/' + firstWithFilling.glazing.image;
                }
            }
        }

        if (
            boxType === 'doorActive'
            && conf.type === 'door'
            && (conf as DoorActiveConfiguration).ModelOptions
        ) {
            const opts = (conf as DoorActiveConfiguration).ModelOptions;
            if (opts?.predefinedLayoutId) {
                predefinedLayout = true;
                if (opts.predefinedLayoutName) {
                    name = opts.predefinedLayoutName;
                }
                img = opts.predefinedLayoutImage ? '/' + opts.predefinedLayoutImage : null;
            }
        }

        return {
            img,
            title,
            name,
            color,
            color2,
            oneGlazing,
            panelType,
            type,
            panelGlazingName,
            panelTrimName,
            innerPanelTrimName,
            show,
            showOptions,
            showTrims,
            boxType,
            disabledButton1,
            predefinedLayout,
        };
    }

    doorOneGlazingType(conf: WindowActiveConfiguration | DoorActiveConfiguration) {
        return conf.OwnedSashesTypes.doorActive && conf.Sashes.length === 1
            ? 'doorActive'
            : 'default';
    }

    canHaveSashColor(conf: DoorActiveConfiguration | WindowActiveConfiguration) {
        return conf.Sashes.every(sash =>
            sash.type && sash.type.type === 'F'
                ? sash.glazing
                  && (sash.glazing.type !== 'deco_panels' && sash.glazing.type !== 'door_panels' || sash.panelType === 'Inset')
                : sash.intSashes.every(
                      field =>
                          field.glazing
                          && (field.glazing.type !== 'deco_panels' && sash.glazing.type !== 'door_panels' || sash.panelType === 'Inset')
                  )
        );
    }

    private getFillingColorsDescription(
        conf: WindowActiveConfiguration | DoorActiveConfiguration,
        filling: ActiveSash['glazing'],
        second = false
    ) {
        let innerColorName = '';
        let outerColorName = '';

        const colorKey = second ? 'selectedColorSecond' : 'selectedColor';

        if (filling && filling[colorKey]) {
            if (filling[colorKey]?.inner?.name) {
                innerColorName = filling[colorKey].inner?.name;
            }

            if (filling[colorKey]?.outer?.name) {
                outerColorName = filling[colorKey].outer?.name;
            }
        }

        return `${innerColorName}/${outerColorName}`;
    }

    getDoorSash(
        conf: WindowActiveConfiguration | DoorActiveConfiguration,
        boxType?: string
    ) {
        let sash: ActiveSash;
        if (conf.Sashes) {
            if (typeof boxType === 'undefined' || boxType === 'default') {
                sash = conf.Sashes[0];
            } else if (boxType === 'doorActive' || boxType === 'doorActiveInner') {
                sash = conf.Sashes.find(s => s.type.type === 'DRA' || s.type.type === 'DOA');
            } else if (boxType === 'doorPassive' || boxType === 'doorPassiveInner') {
                sash = conf.Sashes.find(s => s.type.type === 'DRP' || s.type.type === 'DOP');
            } else if (boxType === 'door') {
                sash = conf.Sashes.find(
                    s =>
                        s.type.type === 'DRA'
                        || s.type.type === 'DRP'
                        || s.type.type === 'DOA'
                        || s.type.type === 'DOP'
                );
            } else if (boxType === 'window') {
                sash = conf.Sashes.find(
                    s =>
                        s.type.type !== 'DRA'
                        && s.type.type !== 'DRP'
                        && s.type.type !== 'DOA'
                        && s.type.type !== 'DOP'
                );
            } else if (boxType === 'topLight') {
                sash = conf.Sashes.find(
                    s => {
                        const frame = conf.Frames.find(f => f.id === s.frameId);
                        return s.type.type === 'F'
                            && s.nearMullions.left === -1 && ((frame && frame.x) || 0) + s.rx === 0
                            && s.nearMullions.top === -1
                            && ((frame && frame.x) || 0) + s.rx + s.rWidth === conf.Width
                });
            } else if (boxType === 'leftLight') {
                sash = conf.Sashes.find(
                    s => {
                        const frame = conf.Frames.find(f => f.id === s.frameId);
                        return s.type.type === 'F'
                            && s.nearMullions.left === -1 && ((frame && frame.x) || 0) + s.rx === 0
                            && (s.nearMullions.top !== -1
                                || ((frame && frame.x) || 0) + s.rx + s.rWidth !== conf.Width
                            )
                });
            } else if (boxType === 'rightLight') {
                sash = conf.Sashes.find(
                    s => {
                        const frame = conf.Frames.find(f => f.id === s.frameId);
                        return s.type.type === 'F'
                            && s.nearMullions.right === -1 && ((frame && frame.x) || 0) + s.rx > 0
                });
            }
        }
        return sash;
    }
}
